// Native variant/cart behavior stays owned by Horizon.
// Anchor landing uses the actual scroll owner, including Horizon's page wrapper.
document.addEventListener('click',event=>{
 const link=event.target.closest('a[href="#folvia-shop"]');
 if(!link)return;
 const anchor=document.getElementById('folvia-shop');if(!anchor)return;
 event.preventDefault();
 anchor.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
});
document.addEventListener('change',event=>{
 const selected=event.target;
 if(selected.matches('.fv3-set-card select')){
  const url=selected.selectedOptions[0]?.dataset.image;
  const image=selected.closest('.fv3-set-card').querySelector('img');
  if(url&&image){image.removeAttribute('srcset');image.src=url}
 }
 if(selected.matches('variant-picker input[type="radio"]')){
  const variants={Sand:'57491879559548',Noir:'57491879592316',Blush:'57491879625084'};
  const id=variants[selected.value];if(!id)return;
  document.querySelectorAll('folvia-travel-set .fv3-set-card:first-child select').forEach(select=>{
   if(![...select.options].some(o=>o.value===id))return;
   select.value=id;select.dispatchEvent(new Event('change',{bubbles:true}));
  });
 }
});
